var map = {
	"./appSettings.config.dev.json": 7283,
	"./appSettings.config.loc.json": 5350,
	"./appSettings.config.prod.json": 3632,
	"./appSettings.config.qa.json": 233,
	"./appSettings.config.stg.json": 7718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 593;